module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rowData.parent_system !== null) ? _c('div', {
    staticClass: "detail-layout"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("請在母系統設定")])]) : _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("系統設定")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("系統名稱")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemName),
      expression: "systemName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.systemName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.systemName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("所屬區域")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaId),
      expression: "areaId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.area), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("管理者")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adminId),
      expression: "adminId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.adminId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)])]), _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("其他設定")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物即期提醒時間(天)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.alert_outdated_day),
      expression: "settings.alert_outdated_day"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.settings.alert_outdated_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "alert_outdated_day", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("前台自動登出(分)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.app_login_timeout),
      expression: "settings.app_login_timeout"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.settings.app_login_timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "app_login_timeout", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.return_to_original_cmpn),
      expression: "settings.return_to_original_cmpn"
    }],
    attrs: {
      "id": "switch-original-cmpn",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.return_to_original_cmpn) ? _vm._i(_vm.settings.return_to_original_cmpn, null) > -1 : (_vm.settings.return_to_original_cmpn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.return_to_original_cmpn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "return_to_original_cmpn", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "return_to_original_cmpn", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "return_to_original_cmpn", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.return_to_original_cmpn
    },
    attrs: {
      "for": "switch-original-cmpn"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("退回原藥盒")])]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.check_amount_first),
      expression: "settings.check_amount_first"
    }],
    attrs: {
      "id": "switch-check-amount",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.check_amount_first) ? _vm._i(_vm.settings.check_amount_first, null) > -1 : (_vm.settings.check_amount_first)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.check_amount_first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "check_amount_first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "check_amount_first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "check_amount_first", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.check_amount_first
    },
    attrs: {
      "for": "switch-check-amount"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("動作前確認藥物")])]), (_vm.settings.type === 'nursing') ? _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.fetch_return_empty_same_time),
      expression: "settings.fetch_return_empty_same_time"
    }],
    attrs: {
      "id": "switch-fetch-and-return-empty",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.fetch_return_empty_same_time) ? _vm._i(_vm.settings.fetch_return_empty_same_time, null) > -1 : (_vm.settings.fetch_return_empty_same_time)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.fetch_return_empty_same_time,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "fetch_return_empty_same_time", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "fetch_return_empty_same_time", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "fetch_return_empty_same_time", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.fetch_return_empty_same_time
    },
    attrs: {
      "for": "switch-fetch-and-return-empty"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("取藥時同時退回藥瓶")])]) : _vm._e()])]), _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("退藥理由")]), _c('hr'), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.returnReason), function(reason, ind) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('span', [_vm._v(_vm._s(reason))])]), _c('th', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteReason(ind)
        }
      }
    }, [_vm._v("刪除")])])])
  }), 0)]), _c('button', {
    staticClass: "btn btn-sm btn-info mb-2",
    on: {
      "click": function($event) {
        _vm.createReason = !_vm.createReason
      }
    }
  }, [_vm._v("新增退藥理由")]), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.createReason) ? _c('div', {
    staticClass: "create-form"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control mr-1",
    attrs: {
      "type": "text",
      "placeholder": "輸入欲新增理由"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("新增")])])]) : _vm._e()])], 1), (_vm.rowData.settings.mode === 'aeth') ? _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("排程設定")]), _c('hr'), _c('div', {
    staticClass: "switch-wrapper mb-2"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.shift_system_status),
      expression: "settings.shift_system_status"
    }],
    attrs: {
      "id": "switch-shift",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.shift_system_status) ? _vm._i(_vm.settings.shift_system_status, null) > -1 : (_vm.settings.shift_system_status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.shift_system_status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "shift_system_status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "shift_system_status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "shift_system_status", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.shift_system_status
    },
    attrs: {
      "for": "switch-shift"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("使用班表系統")])]), _c('div', {
    staticClass: "mb-2"
  }, [(_vm.settings.shift_system_status) ? _c('router-link', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "to": {
        name: 'ShiftArrange'
      }
    }
  }, [_vm._v("檢視班表設定")]) : _vm._e()], 1), _c('div', [_c('router-link', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "to": {
        name: 'ScheduleList'
      }
    }
  }, [_vm._v("檢視手術排程")])], 1)]) : _vm._e()]), _c('hr'), _c('button', {
    staticClass: "btn btn-primary float-right mb-2",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("儲存設定")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "w-75"
  }, [_vm._v("理由")]), _c('th', [_vm._v("動作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c5f6f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ADCManagement/ADCDetail.vue
// module id = 1415
// module chunks = 1